(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bought-today"] && !Shopify.designMode) return;
  try {
    (() => {
  const DAY_MS = 24 * 60 * 60 * 1000;

  document.querySelectorAll('.bought-today-counter').forEach(el => {
    const available = el.dataset.available === 'true';
    if (!available) {
      el.remove();
      return;
    }

    const productId = el.dataset.productId;
    const min = parseInt(el.dataset.min, 10);
    const max = parseInt(el.dataset.max, 10);
    const numberEl = el.querySelector('.bought-number');

    const COUNT_KEY = `bought_today_${productId}`;
    const TIME_KEY = `bought_today_time_${productId}`;

    const now = Date.now();
    const savedCount = localStorage.getItem(COUNT_KEY);
    const savedTime = localStorage.getItem(TIME_KEY);

    let count;

    if (!savedCount || !savedTime || now - savedTime > DAY_MS) {
      count = Math.floor(Math.random() * (max - min + 1)) + min;
      localStorage.setItem(COUNT_KEY, count);
      localStorage.setItem(TIME_KEY, now);
    } else {
      count = savedCount;
    }

    numberEl.textContent = count;
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["live-viewers"] && !Shopify.designMode) return;
  try {
    (() => {
  document.querySelectorAll('.live-viewer-count').forEach(el => {
    // Prevent re-running if section re-renders
    if (el.dataset.initialized) return;
    el.dataset.initialized = 'true';

    const numberEl = el.querySelector('.viewer-number');
    const min = parseInt(el.dataset.min, 10);
    const max = parseInt(el.dataset.max, 10);
    const speed = parseInt(el.dataset.speed, 10);

    const target = Math.floor(Math.random() * (max - min + 1)) + min;
    let current = 0;
    const increment = Math.max(1, Math.ceil(target / 60));

    const interval = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(interval);
      }
      numberEl.textContent = current;
    }, speed);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
